// 导入样式
import './assets/fonts/iconfont.scss'

import PrintDesigner from './components/PrintDesigner.vue'
import TemplatePreview from './components/TemplatePreview.vue'
import { hiprint, hiPrintPlugin } from './components'

// 导出组件
export { PrintDesigner, TemplatePreview, hiprint, hiPrintPlugin }

// 导出默认对象
export default {
  install: (app: any) => {
    app.component('PrintDesigner', PrintDesigner)
    app.component('TemplatePreview', TemplatePreview)
  },
}

// 导出类型
export type { PrintOptions, PrintData } from './components'
